var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Shows/Jobs Grid")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham default-grid",attrs:{"column-defs":_vm.entitiesColumnDefs,"row-data":_vm.entitiesRowData},on:{"row-clicked":_vm.selectEntity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }